import { useLocale } from '../hooks/useT';

export function LocaleSwitcher() {
  const { locale, setLocale } = useLocale();

  return (
    <div className="locale-switcher" role="group" aria-label="Language">
      <button
        type="button"
        className={`locale-btn${locale === 'fr' ? ' active' : ''}`}
        onClick={() => setLocale('fr')}
        aria-pressed={locale === 'fr'}
      >
        FR
      </button>
      <button
        type="button"
        className={`locale-btn${locale === 'en' ? ' active' : ''}`}
        onClick={() => setLocale('en')}
        aria-pressed={locale === 'en'}
      >
        EN
      </button>
    </div>
  );
}
